export default "__VITE_ASSET__ec8d8ce1__"